import{getExtName as r}from"./getExtName.js";import"lodash/last";function t(t,o){var e=r(t).toLowerCase();return"string"==typeof o?e===(o=o.toLowerCase()):!!Array.isArray(o)&&o.indexOf(e)>-1}export{t as checkType};
